import React, { Component } from 'react';
import './task.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from '../../../../Axios/axios';
import { connect } from 'react-redux';
//import * as taskActions from './taskActions';
import * as moduleActions from '../moduleActions';
import * as notificationAction from '../../../Components/Modules/Notification/notificationActions';
import * as taskActions from '../Task/taskActions';
import Countdown from 'react-countdown';


class Task extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
      this.state = {
        allowFilterType:true,
        inactiveType : [],
        moduleName:"TASK",
        page:0,
        expendedId:0,
        blankTask:{
          ACTIVE: true,
          AC_001: 2,
          ARCS: 2,
          DAY: 5,
          DEADLINE: "2021-02-27",
          DESCRIPTION: "This is a description for this task, this may be a long text explaining all step or pratical info needed to complete the task",
          FLAG: 0,
          HOUR: "12:32",
          IU: "R",
          NSYS: 4,
          PER_ARCS: 2,
          PRI_ARCS: 0,
          PRJ_ARCS: 0,
          RECURSION: false,
          REC_DUE_DATE: "/Date(1625007600000+0100)/",
          REC_EFFECTIVE_DATE: "/Date(1622502000000+0100)/",
          REC_FRE_ARCS: 0,
          REC_WEEK: 4,
          REMINDER: 5,
          SUBJECT: "Task to do ",
          Session: null,
          SessionIDE: "",
          Status: 0,
          TDN_ARCS: 0,
          USR_ARCS: 6,
          WINDOWS_NAME: "No Specific view",
        },
        items:[],
        //updateNumber:0,
      };

    }
    
    componentDidMount = () =>{

    }

    hideBlocks = () =>{

    }

    expendTask = (id) =>{
      if(this.state.expendedId === id){
        this.setState({expendedId:0});
      }else{
        this.setState({expendedId:id});
      }
      
    }
    



    buildModuleBlock = () => {
      var item = this.state.blankTask;
      item.RECURSION = true;
      var items = [...this.props._tasks];
      items.push(item);
      var contentList = items.map((item,i)=>{
        var dueDate = this.buildTimeDueDate(item.DEADLINE,item.HOUR);
        var reminingTime = this.buildTimeReminingTime(item.DEADLINE,item.HOUR);

        return <div key={i} className={item.RECURSION?"item-task recursive":"item-task"} onClick={this.expendTask.bind(this,item.ARCS)}>
          <div className="task-header" title={item.RECURSION?"Next deadline is in "+reminingTime:"Task deadline in"+reminingTime}>
            <FontAwesomeIcon icon={item.RECURSION?"history":"bell"}/>
            <div className="task-subject">{item.SUBJECT}</div>
            
            <FontAwesomeIcon icon={this.state.expendedId === item.ARCS?"minus-square":"plus-square"}/>  
          </div>
          <div className={"task-body "+(this.state.expendedId === item.ARCS?"show":"hide")}>
              <div className="task-body-description">{item.DESCRIPTION}</div>
              <div className="task-body-footer">
                <div>{item.WINDOWS_NAME}</div>
                <div className="task-actions" title="mark as complete"><FontAwesomeIcon icon="check-square"/></div>
              </div>
          </div>
          <div className="task-footer">
            <div className="task-date"><Countdown 
              overtime="true" 
              renderer={
                props => 
                  <div className={props.total>0? (props.total<360000000?"countdown near":"countdown ok"):"countdown overdue"}>
                    {props.total>360000000?props.days+" day(s) left":"today "+props.hours+":"+props.minutes+":"+props.seconds}
                  </div>
              } 
              date={new Date(item.DEADLINE+" "+item.HOUR).getTime()} 
              />
              <div>({dueDate})</div>
            </div>
          </div>
        </div>;
      });
      



      return(
        <div className="moduleBlock">
          <div className="">
            {contentList}
          </div>
        </div>
      )
    }

    buildTimeDueDate = (date,time) =>{
      return date+" "+time;
    }
    buildTimeReminingTime = (date,time) =>{

      return "10 minutes";
    }
  
    render() {
      var moduleBlock = this.buildModuleBlock();
      var moduleFilter = null;
      var alert = false;

      return (
        <div   className={this.props.extendedModule === this.state.moduleName?"header-column extended":"header-column"}  >
          <FontAwesomeIcon icon="check-square" onClick={this.props.toggleExpand.bind(this,this.state.moduleName)}/> 
          {alert? <div className="alert"></div>:null}
          <div className="extendBlocks">
            <div className="extendBlocksHeader">
              <div className="headerTitle">
                {this.state.moduleName} pannel
              </div>
              {moduleFilter}
            </div>
            {moduleBlock}
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      notificationHistory: state.appReducer.notificationHistory,
      extendedModule: state.appReducer.extendedModule,
      _transfertObject:state.apiReducer.transfertObject,
      _TDI:state.apiReducer.TDI,
      _tasks:state.apiReducer.tasks,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      toggleExpand: (type) => dispatch(moduleActions.toggleExpand(type)),
      _logError:(error,title,endPoint) =>dispatch(notificationAction.logError(error,title,endPoint)),
      _createTask:() =>dispatch(taskActions.createTask()),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Task);
